"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Footer = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = function styles(theme) {
  return {
    root: {
      display: "flex",
      flex: 0
    }
  };
};

var Footer = function Footer(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["classes", "className"]);

  return /*#__PURE__*/_react["default"].createElement("footer", _extends({
    className: (0, _clsx["default"])("HypFooter-root", classes.root, className),
    id: "footer"
  }, props));
};

exports.Footer = Footer;
Footer.defaultProps = {
  classes: {}
};
Footer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Footer",
  "props": {
    "classes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    }
  }
};
var exportComponent = (0, _core.withStyles)(styles, {
  name: "HypFooter"
})(Footer); // copy static props for storybook

if (process.env.NODE_ENV !== "production") {
  exportComponent.displayName = Footer.displayName;
  exportComponent.propTypes = Footer.propTypes;
  exportComponent.defaultProps = Footer.defaultProps;
}

var _default = exportComponent;
exports["default"] = _default;